import strings from 'localization/strings';

const conversationStatuses = {
    unhandled: {},
    waitingForOwner: {},
    waitingForTenant: {},
    waitingForStorage365: {},
    completed: {}
};

Object.keys(conversationStatuses).forEach(key => {
    conversationStatuses[key].key = key;
});

strings.addLoadCallback(() => {
    Object.values(conversationStatuses).forEach(o => {
        o.title = strings.conversationStatuses[o.key];
    });
});

export default conversationStatuses;
